import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  selectProductIdsFieldsRule,
  selectProductTitleFieldsRule,
  selectProductTitlePrefixFormat,
  selectShowWspdPriceRule,
} from '@epicuro-next/state/p-basket-state';
import { selectShowWholeSalePrices } from '@epicuro-next/state/user-state';
import { select, Store } from '@ngrx/store';
import { Product, ProductPriceRanges } from 'graphql-api/gql-api-interfaces';
import { map } from 'rxjs/operators';

@Component({
  selector: 'epc-product-card-header',
  styleUrls: ['./product-card-header.component.scss'],
  templateUrl: './product-card-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ProductCardHeaderComponent {
  @Input() public product: Product;
  @Input() public showMarkup = true;
  @Input() public prices: ProductPriceRanges[] = [];
  @Input() public compactView = false;
  @Input() public isSearchV2Enabled = false;
  @Input() public showProductTitle = true;

  public readonly idFields$ = this.store.select(selectProductIdsFieldsRule);

  public readonly titleFields$ = this.store.select(
    selectProductTitleFieldsRule,
  );

  public readonly titlePrefixFields$ = this.store.select(
    selectProductTitlePrefixFormat,
  );

  public readonly showWspdPrice$ = this.store.select(selectShowWspdPriceRule);

  public showWholeSalePrice$ = this.store.pipe(
    select(selectShowWholeSalePrices),
    map(Boolean),
  );

  constructor(private readonly store: Store) {}
}
